import {
  from_hex as fromHex,
  crypto_pwhash as cryptoPwhash,
  randombytes_buf as randombytesBuf,
  crypto_pwhash_SALTBYTES as cryptoPwhashSALTBYTES,
  crypto_pwhash_ALG_ARGON2ID13 as cryptoPwhashALGARGON2ID13,
  ready,
} from 'libsodium-wrappers';
import { md5Hash } from './hashes';

enum MemLimit {
  m64 = 67108864,
  m32 = m64 / 2,
  m16 = m32 / 2,
  m8 = m16 / 2,
}

export const deriveKey = async (string: string, sSalt: string) => {
  await ready;
  const salt = fromHex(sSalt);
  return cryptoPwhash(
    32,
    string,
    salt,
    10,
    MemLimit.m16,
    cryptoPwhashALGARGON2ID13,
    'hex',
  );
};

export const generateSalt = async () => {
  await ready;
  return randombytesBuf(cryptoPwhashSALTBYTES, 'hex');
};

export const derivePasswordKey = async (password: string, employeeAccountId: string) => (
  deriveKey(password, md5Hash(employeeAccountId))
);
